// extracted by mini-css-extract-plugin
export default {"root":"pVWd1m1R8_cpTVCgC1op","primary":"qn3mjUeKaC1MFe3L4747","disabled":"TKY12SeuWD9Yj0FqtemV","placeHolderShimmer":"mtb3iU_dF6ER7Po9Ymot"};